export const PRODUCTS = {


  "OUO_FH_37_59": {
    batch_id: "OUO_FH_37_59",
    product: "Himalayan Forest Honey",
    village: {
      name: "Satta",
      district: "Uttarkashi",
      state: "Uttarakhand",
      elevation_ft: 7020,
      description:
        "Satta is a remote Himalayan village in the Mori block of Uttarkashi district, nestled among forested slopes, mountain streams, and traditional farming landscapes of the western Garhwal Himalaya. Its diverse forests and seasonal flowering support rich pollinator and honeybee activity, with the surrounding landscape providing natural forage across changing seasons. The village’s honey reflects this floral diversity shaped by altitude, forest vegetation, and local mountain ecology. Though quieter and less known than some of Uttarkashi’s better known valleys, Satta represents a landscape where traditional farming, Himalayan forests, and locally harvested forest honey remain closely connected to the rhythms of mountain life.",
    },
    farmer: {
      name: "Dinesh Rawat",
      age: 40,
      gender: "Male",
      image:
        "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/honey/img_1.jpeg",
      bio: "Dinesh Rawat is a traditional honey farmer from Satta village in the Mori block of Uttarkashi, working closely with the surrounding Himalayan forests and their seasonal flowering cycles. He harvests honey by carefully cutting the hive and collecting the honey by hand, wearing proper protective clothing to ensure a safe and careful harvest. Once collected, the honey is naturally filtered and gently warmed by the sun to help it flow, without industrial processing. Nothing is added and nothing is removed from the honey, allowing Dinesh to preserve the natural character and floral richness of the Himalayan forest from hive to bottle.",
      calendar: [
        // { icon: "🌱", phase: "Sowing", period: "Late May to early July" },
        { icon: "🍯", phase: "First Harvest Season", period: "April" },
        { icon: "🐝", phase: "Second Harvest Season", period: "October" },
      ],
      processing: {
        practices: ["Hive Harvested", "Naturally Filtered"],
        description:
          "Dinesh Rawat carefully harvests the honey by cutting the hive and collecting the honey by hand, using proper protective clothing throughout the process. The freshly collected honey is naturally filtered to remove only visible hive particles, then gently warmed by the sun to help it flow naturally. Nothing is added and nothing is removed from the honey, preserving the character of the Himalayan forest, from hive to bottle.",
      },
      videos: [
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/honey/vid_1.mp4",
          // label: "Farm drone shot", 
        },
      ],
      farms: [
        {
          label: "Farm 1",
          url: "https://www.google.com/maps/d/u/2/edit?mid=1lpDSOsYojj8RUGMrEeaIH8nGVKW0Zkk&usp=sharing",
        },
      ],
      nutritionFacts: {
  servingsPerContainer: null,
  servingSize: "100 g",
  perLabel: "Nutrition Facts (per 100 gms)",
  calories: 912,
  basis: null,
  rows: [
    { nutrient: "Total Fat (Saturated+Trans) 0g", rda: "" },
    { nutrient: "Sodium 4mg", rda: "" },
    { nutrient: "Total Carbohydrate 82g", rda: "" },
    { nutrient: "Total Sugars 82g", rda: "" },
    { nutrient: "Added Sugars 0g", rda: "" },
    { nutrient: "Protein 0.3g", rda: "" },
  ],
        footnote: "* % RDA per serving, based on ICMR-NIN 2020 Recommended Dietary Allowance for a sedentary adult WOMAN (protein 46 g, fibre 30 g, calcium 1000 mg, iron 29 mg, magnesium 370 mg, zinc 13 mg, potassium 3500 mg, sodium 2000 mg, vitamin D 15 mcg). — = no ICMR RDA prescribed; declared as amount only, as per FSSAI practice.",
      },
    },
  },









  "OUO_WR_47_23": {
    batch_id: "OUO_WR_47_23",
    product: "Himalayan White Rajma",
    village: {
      name: "Hurri",
      district: "Uttarkashi",
      state: "Uttarakhand",
      elevation_ft: 6890,
      description:
        "Huri is a small, sparsely populated Himalayan settlement in the upper reaches of Uttarkashi district, perched above the Bhagirathi river system. It sits within the larger ecological gradient that includes Bhangeli, Dharali, Harsil, Mukhba, and the Gangotri–Gaumukh corridor — a zone known for its cold-temperate forests, glacial streams, rich organic soils, and centuries-old mountain farming systems. Though remote and often overshadowed by the better-known Harsil valley villages, Huri plays a strategic role in the region's agro-biodiversity, especially for rajma, tempering herbs, local millets, and Badri cattle.",
    },
    farmer: {
      name: "Purushottam Negi",
      age: 42,
      gender: "Male",
      image:
        "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/puroshattam.jpg",
      bio: "Purushottam Negi is a dedicated farmer from Huri village who maintains old seed lines of Himalayan rajma and preserves traditional high-mountain farming systems. Working on steep, terraced slopes fed by glacial streamlets, he farms entirely by hand with support from his family — no chemicals, no mechanisation, just inherited knowledge and deep familiarity with his land. His family has cultivated the same micro-plots for generations, giving him an intuitive understanding of soil behaviour, water movement, and seasonal patterns unique to Huri's high-altitude ecology.",
      calendar: [
        { icon: "🌱", phase: "Sowing", period: "Late May to early July" },
        { icon: "🌿", phase: "Staking", period: "August" },
        { icon: "🌾", phase: "Harvest", period: "October" },
      ],
      processing: {
        practices: ["Sun Dried", "Hand Sorted"],
        description:
          "Purushottam's family — comprising his wife, brother, and extended family — works together on sun-drying, winnowing, and hand-sorting, ensuring high-quality beans for every OUO batch. Village-level processed and hand-cleaned with the same care and attention as the grain they keep for their own homes.",
      },
      videos: [
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/puroshattam_1.mp4",
          label: "Farm drone shot",
        },
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/sundry_1.mp4",
          label: "Sun drying of white rajma",
        },
      ],
      farms: [
        {
          label: "Farm 1",
          url: "https://www.google.com/maps/d/u/2/edit?mid=1971S56sI4x85gh3Oq8u1LvIoIxQMv0U&usp=sharing",
        },
      ],
      nutritionFacts: {
        servingsPerContainer: "about 6 servings per container",
        servingSize: "85 g",
        perLabel: "Amount per serving",
        calories: 110,
        basis: "Basis: cooked / boiled.",
        rows: [
          { nutrient: "Total Fat 0g", rda: "—" },
          { nutrient: "Cholesterol 0mg", rda: "—" },
          { nutrient: "Sodium 0mg", rda: "0%" },
          { nutrient: "Total Carbohydrate 19g", rda: "—" },
          { nutrient: "Dietary Fiber 6g", rda: "20%", indent: true },
          { nutrient: "Total Sugars 0g", rda: "", indent: true },
          { nutrient: "Includes 0g Added Sugars", rda: "—", indent: true },
          { nutrient: "Protein 7g", rda: "16%" },
          { nutrient: "Vitamin D 0mcg", rda: "0%" },
          { nutrient: "Calcium 24mg", rda: "2%" },
          { nutrient: "Iron 2.5mg", rda: "9%" },
          { nutrient: "Potassium 344mg", rda: "10%" },
          { nutrient: "Magnesium 38mg", rda: "10%" },
          { nutrient: "Zinc 0.9mg", rda: "7%" },
        ],
        footnote: "* % RDA per serving, based on ICMR-NIN 2020 Recommended Dietary Allowance for a sedentary adult WOMAN (protein 46 g, fibre 30 g, calcium 1000 mg, iron 29 mg, magnesium 370 mg, zinc 13 mg, potassium 3500 mg, sodium 2000 mg, vitamin D 15 mcg). — = no ICMR RDA prescribed; declared as amount only, as per FSSAI practice.",
      },
    },
  },

  "OUO_RR_15_62": {
    batch_id: "OUO_RR_15_62",
    product: "Himalayan Red Rajma",
    village: {
      name: "Bhangeli",
      district: "Uttarkashi",
      state: "Uttarakhand",
      elevation_ft: 7546,
      description:
        "Bhangeli is a close-knit terraced village in Uttarkashi district, perched at 7,546 ft on the western slope of the Bhagirathi valley. It is the base village for OUO's Himalayan sourcing cluster — PSG certified, and one of the few settlements in this region that has maintained both organic farming practices and traditional seed diversity across generations. Surrounded by mixed conifer and oak forest, with cold, clean glacial streams feeding the terraced fields, Bhangeli produces some of the finest red rajma, tempering spices, and dairy in the upper Himalayan corridor.",
    },
    farmer: {
      name: "Keerthan Devi",
      age: 55,
      gender: "Female",
      image:
        "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/red%20rajma/img1.jpeg",
      bio: "Keerthan Devi is one of the most experienced farmers in Bhangeli, having cultivated traditional Himalayan red rajma on the same terraced plots for over four decades. At 59, she is a keeper of rare seed varieties grown in this valley since her grandmother's time. She manages her farm with quiet precision — reading the soil, the weather, and the slope the way only someone who has spent a lifetime on a particular piece of land can. Her red rajma is prized for its deep burgundy colour, earthy flavour, and exceptional cooking quality.",
      calendar: [
        { icon: "🌱", phase: "Sowing", period: "Late May to early June" },
        { icon: "🌿", phase: "Staking", period: "July – August" },
        { icon: "🌾", phase: "Harvest", period: "October – November" },
      ],
      processing: {
        practices: ["Sun Dried", "Hand Sorted", "Stone Cleaned"],
        description:
          "Keerthan Devi and her extended family spend weeks each October laying beans out on stone rooftop terraces to sun-dry. Each batch is hand-sorted multiple times — removing splits, discoloured beans, and debris — before being cleaned and packed. It is slow, careful work, done the way it has always been done.",
      },
      videos: [
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/red%20rajma/vid1.mp4",
          label: "Preparing land for seeding red rajma",
        },
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/red%20rajma/vid2.mp4",
          label: "Farmer placing support sticks for red rajma",
        },
      ],
      farms: [
        {
          label: "Farm 1",
          url: "https://www.google.com/maps/d/u/2/edit?mid=1rE-8ALyYDUFhGOWnkqE4cKGmJKZPwh8&usp=sharing",
        },
        {
          label: "Farm 2",
          url: "https://www.google.com/maps/d/u/2/edit?mid=1HVWOSj_uokQ6ijbU9ZhW-_wwmNv-zGo&usp=sharing",
        },
      ],
      nutritionFacts: {
        servingsPerContainer: "about 6 servings per container",
        servingSize: "85 g",
        perLabel: "Amount per serving",
        calories: 110,
        basis: "Basis: cooked / boiled.",
        rows: [
          { nutrient: "Total Fat 0g", rda: "—" },
          { nutrient: "Cholesterol 0mg", rda: "—" },
          { nutrient: "Sodium 0mg", rda: "0%" },
          { nutrient: "Total Carbohydrate 19g", rda: "—" },
          { nutrient: "Dietary Fiber 5g", rda: "18%", indent: true },
          { nutrient: "Total Sugars 0g", rda: "", indent: true },
          { nutrient: "Includes 0g Added Sugars", rda: "—", indent: true },
          { nutrient: "Protein 6g", rda: "14%" },
          { nutrient: "Calcium 24mg", rda: "2%" },
          { nutrient: "Iron 2.5mg", rda: "9%" },
          { nutrient: "Potassium 343mg", rda: "10%" },
          { nutrient: "Magnesium 38mg", rda: "10%" },
          { nutrient: "Zinc 0.9mg", rda: "7%" },
        ],
        footnote: "* % RDA per serving, based on ICMR-NIN 2020 Recommended Dietary Allowance for a sedentary adult WOMAN (protein 46 g, fibre 30 g, calcium 1000 mg, iron 29 mg, magnesium 370 mg, zinc 13 mg, potassium 3500 mg, sodium 2000 mg, vitamin D 15 mcg). — = no ICMR RDA prescribed; declared as amount only, as per FSSAI practice.",
      },
    },
  },

  "OUO_TS_83_41": {
    batch_id: "OUO_TS_83_41",
    product: "Wild Himalayan Tempering Spice",
    village: {
      name: "Bhangeli",
      district: "Uttarkashi",
      state: "Uttarakhand",
      elevation_ft: 7546,
      description:
        "Bhangeli is a close-knit terraced village in Uttarkashi district, perched at 7,546 ft on the western slope of the Bhagirathi valley. It is the base village for OUO's Himalayan sourcing cluster — PSG certified, and one of the few settlements in this region that has maintained both organic farming practices and traditional seed diversity across generations. The upper forest belts above Bhangeli are rich in wild aromatic plants — jakhiya, timur, and other native herbs — forming the basis for the region's distinctive wild-harvested spice tradition.",
    },
    farmer: {
      name: "Ajbar Singh Rana",
      age: 55,
      gender: "Male",
      image:
        "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/laadu/img1.jpeg",
      bio: "Ajbar Singh Rana is a wild forager and farmer from Bhangeli with encyclopaedic knowledge of the high-altitude flora surrounding his village. He harvests wild tempering spices — including jakhiya (Cleome viscosa) and timur (Himalayan Sichuan pepper) — from the upper forest belts above 6,562 ft. His work requires deep ecological knowledge: knowing which slopes hold which plants, when each species reaches peak potency, and how to harvest without depleting wild stock. He has been doing this for over thirty years, and his batches are among the most aromatic produced in the valley.",
      calendar: [
        { icon: "🌸", phase: "Wild Blooming", period: "Early May onwards" },
        { icon: "🌿", phase: "Wild Harvest", period: "Late June – July end" },
        { icon: "☀️", phase: "Drying, Sorting & Packaging", period: "August – September" },
      ],
      processing: {
        practices: ["Wild Foraged", "Stone-Smashed", "Shadow Dried"],
        description:
          "Our single origin tadka herb is a wild herb of the Allium family that grows exclusively on the high alpine meadows of the Gangotri Valley at 11,410 ft above sea level. It has never been successfully cultivated at lower altitudes. No farm produces it. No greenhouse replicates it. It grows where it chooses — on rocky, windswept slopes above the treeline, in thin air, under intense UV, nourished only by glacial meltwater and Himalayan soil that has never known a chemical.\n\nEvery year, the mountain community of the Gangotri valley climbs into these meadows to forage it. The journey takes 2–3 days each way through terrain that has no roads, no shortcuts, and no margin for error. The herb is picked at its peak — when the volatile oils in the leaves are at their most concentrated — then carried back down to the village.\n\nIn Bhangeli, it is stone-smashed by hand. Not chopped. Not machine-ground. Stone-smashed — the way it has been done for as long as anyone can remember — which bruises the cells open and releases the full aromatic complexity of the herb without heat damage. It is then shadow-dried for 3–4 days in the cool mountain air, away from direct sunlight, preserving every volatile oil, every antioxidant, every molecule of flavour and potency that the alpine meadow put into it.\n\nWhat reaches you in this jar is exactly that. Nothing more. Nothing less. A pinch of this spice carries the altitude, the terrain, and two days of walking.",
      },
      customSupplyChain: [
        { icon: "🏔️", title: "Alpine Meadow — Gangotri Valley", desc: "11,410 ft above sea level · above the treeline · glacial meltwater · soil that has never known a chemical" },
        { icon: "🚶", title: "2–3 Day Forage Journey", desc: "Climbed to on foot each season — no roads, no shortcuts, carried back down by hand at peak potency" },
        { icon: "🪨", title: "Stone-Smashed & Shadow Dried", desc: "Bhangeli village — hand-smashed on stone, shadow-dried for 3–4 days in cool mountain air" },
        { icon: "📦", title: "Packed in Bhangeli", desc: "Sealed with Himalayan air inside" },
        { icon: "🚚", title: "First Mile Logistics", desc: "Courier partner / pickup hub — Uttarkashi" },
        { icon: "🏠", title: "Last Mile Delivery", desc: "Your home — a pinch of altitude, terrain, and two days of walking" },
      ],
      videos: [
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/laadu/vid1.mp4",
          // label: "Laadu picking in himalayan meadow",
        },
        // {
        //   url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/laadu/vid1.mp4",
        //   label: "Laadu picking in himalayan meadow",
        // }
      ],
      farms: [
        {
          label: "Harvest Area 1",
          url: "https://www.google.com/maps/d/u/2/edit?mid=1md4030JcVqZb_OVi_eYp-DfrkwKCGmY&usp=sharing",
        },
      ],
      nutritionFacts: {
        perLabel: "Amount per 100 g",
        calories: 290,
        rows: [
          { nutrient: "Total Fat 4g", rda: "—" },
          { nutrient: "Saturated Fat 0.7g", rda: "—", indent: true },
          { nutrient: "Trans Fat 0g", rda: "—", indent: true },
          { nutrient: "Sodium 30mg", rda: "2%" },
          { nutrient: "Total Carbohydrate 55g", rda: "—" },
          { nutrient: "Dietary Fiber 25g", rda: "83%", indent: true },
          { nutrient: "Total Sugars 6g", rda: "", indent: true },
          { nutrient: "Includes 0g Added Sugars", rda: "—", indent: true },
          { nutrient: "Protein 20g", rda: "43%" },
          { type: "header", label: "Hero profile — naturally occurring" },
          { nutrient: "Calcium 642mg", rda: "64%" },
          { nutrient: "Potassium 2253mg", rda: "64%" },
          { nutrient: "Choline 161mg", rda: "—" },
          { nutrient: "Copper 0.29mg", rda: "17%" },
          { nutrient: "Folate 16.5mcg", rda: "8%" },
          { nutrient: "Vitamin A 131 IU", rda: "5%" },
          { nutrient: "Vitamin C 2.2mg", rda: "3%" },
          { nutrient: "Beta-carotene 0.79mg", rda: "—" },
        ],
        footnote: "* % RDA per serving, based on ICMR-NIN 2020 Recommended Dietary Allowance for a sedentary adult WOMAN (protein 46 g, fibre 30 g, calcium 1000 mg, iron 29 mg, magnesium 370 mg, zinc 13 mg, potassium 3500 mg, sodium 2000 mg, vitamin D 15 mcg). — = no ICMR RDA prescribed; declared as amount only, as per FSSAI practice.",
      },
    },
  },

  "OUO_GH_29_74": {
    batch_id: "OUO_GH_29_74",
    product: "Badri Cow Ghee",
    village: {
      name: "Bhangeli",
      district: "Uttarkashi",
      state: "Uttarakhand",
      elevation_ft: 7546,
      description:
        "Bhangeli is a close-knit terraced village in Uttarkashi district, perched at 7,546 ft on the western slope of the Bhagirathi valley. It is the base village for OUO's Himalayan sourcing cluster — PSG certified, and one of the few settlements in this region that has maintained both organic farming practices and traditional land stewardship across generations. The high-altitude meadows surrounding Bhangeli are home to Badri cows — a compact, hardy native Himalayan breed that has grazed these pastures for centuries.",
    },
    farmer: {
      name: "Nirmala Rawat",
      age: 40,
      gender: "Female",
      image:
        "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/Ghee/img1.jpeg",
      bio: "Nirmala Rawat tends a small herd of Badri cows — a compact, hardy native Himalayan breed that has grazed these high-altitude pastures for centuries. The Badri cow produces less milk than commercial dairy breeds, but what it gives is exceptionally rich, shaped by alpine meadow grasses and wild herbs. Nirmala uses the traditional bilona method: culturing fresh milk into yoghurt, hand-churning it into butter over two to three days, then gently simmering the butter in a copper vessel until it clarifies into pure ghee. No shortcuts, no additives — just milk, culture, fire, and time.",
      calendar: [
        { icon: "🐄", phase: "Peak Grazing Season", period: "May – September" },
        { icon: "🥛", phase: "Milk Collection", period: "Year-round" },
        { icon: "🫙", phase: "Churning & Clarification", period: "Year-round" },
      ],
      processing: {
        practices: ["Traditional Bilona Method", "Copper Vessel", "A2 Milk", "Small-Batch"],
        description:
          "Each evening, fresh milk from Nirmala's Badri herd is gently heated, cooled to warm, then seeded with a spoonful of live yoghurt culture saved from the previous batch — a starter the family has maintained for years. Left overnight, this sets into a thick, naturally soured dahi. The next morning, Nirmala uses the bilona — a carved wooden churner rotated rapidly between both palms with a rope — churning the yoghurt for one to two hours until soft white makhan (hand-churned butter) separates and rises to the surface. This makhan is then simmered slowly in a copper vessel over a low flame until the water evaporates, the milk solids settle and brown lightly at the bottom, and the fat clarifies into a golden, aromatic ghee. It is strained through muslin and poured into glass jars while still warm.",
      },
      traceabilityWIP: true,
      grazingMap: {
        label: "Alpine Meadows — Gidara Bugyal",
        url: "https://www.google.com/maps/d/u/2/edit?mid=1GB2FRBt5Sex-EnuO68M57eLXXO_wSWY&usp=sharing",
      },
      breedInfo: {
        title: "Why Badri Cow Ghee is Different",
        paragraphs: [
          "The Badri breed has grazed the upper slopes of Uttarakhand for centuries — living above 7,000 ft where Brahmi, Ashwagandha, Jatamansi, and dozens of wild medicinal herbs grow between the rocks. These herbs pass through her milk.",
          "Her A2 milk contains no A1 beta-casein — the protein variant that many people find difficult to digest. This is why Badri cow ghee sits differently in the body. Lighter. Cleaner. Recognised.",
          "Badri cow is a protected indigenous breed, certified by the National Bureau of Animal Genetic Resources (NBAGR), Government of India.",
        ],
      },
      indigenousMethod: {
        heading: "Badri Cow Ghee Indigenous Production Method",
        subheading: "The bilona method — milk → dahi → makhan → ghee — done by hand, over fire, in copper.",
        ghResidueNote: "We keep our GR (Ghee Residues) inside the bottle — the toasted milk-solids at the base of every jar are pure gold, packed with fat-soluble nutrients, and nothing gets filtered out.",
      },
      nutritionFacts: {
        heading: "Nutrition Facts — Himalayan Badri Cow Ghee",
        servingsPerContainer: "about 8 servings per 120 g jar · lab-tested values",
        servingSize: "15 g (~1 tbsp)",
        perLabel: "Amount per 100 g",
        calories: 900,
        caloriesUnit: "kcal",
        rows: [
          { nutrient: "Total Fat 99.97 g", rda: "—", benefit: "Nearly pure milk fat (99.98%)." },
          { nutrient: "Saturated Fat 66.8 g", rda: "—", indent: true, benefit: "Heat-stable — high smoke point (~250°C); does not break down or oxidise when you fry or temper." },
          { nutrient: "Monounsaturated Fat 27.95 g", rda: "—", indent: true, benefit: "Heart-friendly fats — the same family found in olive oil." },
          { nutrient: "Polyunsaturated Fat 2.54 g", rda: "—", indent: true, benefit: "Provides essential fatty acids." },
          { nutrient: "Trans Fat 2.68 g", rda: "—", indent: true, benefit: "NATURAL ruminant trans fat (incl. CLA precursors) — not industrial trans fat. Declared honestly per FSSAI." },
          { nutrient: "Cholesterol 185.9 mg", rda: "—", benefit: "Dietary cholesterol, as in all pure dairy fat." },
          { nutrient: "Sodium 0 mg", rda: "0%", benefit: "No added salt." },
          { nutrient: "Total Carbohydrate 0 g", rda: "—", benefit: "Pure fat — no carbohydrate." },
          { nutrient: "Total Sugars 0 g", rda: "", indent: true },
          { nutrient: "Includes 0 g Added Sugars", rda: "—", indent: true, benefit: "No sugar — keto- and fasting-friendly." },
          { nutrient: "Protein 0 g", rda: "0%", benefit: "Clarified fat — milk proteins removed." },
          { type: "header", label: "Hero profile — naturally occurring" },
          { nutrient: "Vitamin A 2,057 IU", rda: "73%", benefit: "Supports vision, skin and immunity; fat-soluble, so well absorbed in ghee." },
          { nutrient: "Beta-carotene 1.13 mg", rda: "—", benefit: "Natural antioxidant and the source of ghee's golden colour — a marker of true grass/herb feeding." },
          { nutrient: "CLA (Conjugated Linoleic Acid)", rda: "present**", benefit: "From grass-fed milk; studied for metabolism and body composition." },
          { nutrient: "Omega-3 fatty acids", rda: "present**", benefit: "Anti-inflammatory essential fats from herb-fed grazing." },
          { nutrient: "Butyric acid (butyrate)", rda: "present**", benefit: "Ghee is a natural source of butyrate, a short-chain fat traditionally valued for gut health." },
        ],
        footnote: "* % RDA per 100 g, ICMR-NIN 2020 (sedentary adult woman; vitamin A 840 mcg RAE ~ 2,800 IU). A 15 g serving provides ~11% of the vitamin A RDA and ~0.4 g trans fat.",
        extraFootnote: "** present = naturally occurring, not separately quantified in this report — request a specific assay to print a value. Ghee proteins (incl. casein) are largely removed in clarification, so \"A2 / no A1\" is a breed & sourcing statement.",
      },
      videos: [
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/Ghee/vid1.mp4",
          label: "Badri cattle grazing in high-altitude meadows 01",
        },
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/Ghee/vide2.mp4",
          label: "Badri cattle grazing in high-altitude meadows 02",
        },
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/cow_03.mp4",
          label: "Badri cattle grazing in high-altitude meadows 03",
        },
      ],
      farms: [],
    },
  },

  "OUO_BS_56_18": {
    batch_id: "OUO_BS_56_18",
    product: "Himalayan Black Soyabean",
    village: {
      name: "Dewara",
      district: "Uttarkashi",
      state: "Uttarakhand",
      elevation_ft: 5906,
      description:
        "Dewara is a quiet terrace-farming village in the Bhagirathi watershed of Uttarkashi district, situated at approximately 5,906 ft. It lies in a transition zone between the mid-mountain temperate belt and the upper Himalayan ecology — an elevation range that produces exceptional legumes. The village is small and relatively isolated, connected by a mountain track to the main Uttarkashi road. Its farming community has maintained traditional black soyabean seed lines for generations, a practice increasingly rare as modern yellow varieties have replaced indigenous strains across much of northern India. The soil here is deep, loamy, and rich in organic matter — a legacy of centuries of composting and traditional land management.",
    },
    farmer: {
      name: "Bhawana Rana",
      age: 38,
      gender: "Female",
      image:
        "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/black%20soybeans/img1.jpeg",
      bio: "Bhawana Rana is a progressive farmer from Dewara who has continued cultivating the traditional black soyabean varieties her family has grown for generations. She is one of a small group of farmers in Uttarkashi who still maintains these rare seed lines, resisting the widespread shift to commercial yellow soyabean. Bhawana Rana farms entirely organically, using composted farmyard manure and traditional crop rotation that keeps her soil productive without external inputs. Her black soyabean is nutty, protein-rich, and carries the unmistakable character of high-altitude Himalayan soil.",
      calendar: [
        { icon: "🌱", phase: "Sowing", period: "June – July" },
        { icon: "🌸", phase: "Flowering", period: "August – September" },
        { icon: "🌾", phase: "Harvest", period: "October – November" },
      ],
      processing: {
        practices: ["Sun Dried", "Hand Sorted", "Stone Polished"],
        description:
          "Bhawana Rana and her family sort and clean each batch of black soyabean by hand, checking carefully for splits and defects before packaging. The beans are sun-dried on traditional drying mats and stored in sealed containers to preserve freshness and the characteristic deep colour.",
      },
      videos: [
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/black%20soybeans/vid1.mp4",
          // label: "Terraced farm overview — Dewara",
        }
      ],
      farms: [
        {
          label: "Farm 1",
          url: "https://www.google.com/maps/d/u/2/edit?mid=1dbBDXhlISLMUL3JPGghKk8UWtMpdpgQ&usp=sharing",
        },
      ],
      nutritionFacts: {
        servingsPerContainer: "about 6 servings per container",
        servingSize: "90 g",
        perLabel: "Amount per serving",
        calories: 160,
        rows: [
          { nutrient: "Total Fat 8g", rda: "—" },
          { nutrient: "Saturated Fat 1g", rda: "—", indent: true },
          { nutrient: "Cholesterol 0mg", rda: "—" },
          { nutrient: "Sodium 0mg", rda: "0%" },
          { nutrient: "Total Carbohydrate 8g", rda: "—" },
          { nutrient: "Dietary Fiber 5g", rda: "18%", indent: true },
          { nutrient: "Total Sugars 2g", rda: "", indent: true },
          { nutrient: "Includes 0g Added Sugars", rda: "—", indent: true },
          { nutrient: "Protein 15g", rda: "32%" },
          { nutrient: "Calcium 92mg", rda: "9%" },
          { nutrient: "Iron 4.6mg", rda: "16%" },
          { nutrient: "Potassium 464mg", rda: "13%" },
          { nutrient: "Magnesium 77mg", rda: "21%" },
          { nutrient: "Zinc 1.1mg", rda: "8%" },
        ],
        footnote: "* % RDA per serving, based on ICMR-NIN 2020 Recommended Dietary Allowance for a sedentary adult WOMAN (protein 46 g, fibre 30 g, calcium 1000 mg, iron 29 mg, magnesium 370 mg, zinc 13 mg, potassium 3500 mg, sodium 2000 mg, vitamin D 15 mcg). — = no ICMR RDA prescribed; declared as amount only, as per FSSAI practice.",
      },
    },
  },

  "OUO_RC_37_92": {
    batch_id: "OUO_RC_37_92",
    product: "Himalayan Red Rice",
    village: {
      name: "Purola",
      district: "Uttarkashi",
      state: "Uttarakhand",
      elevation_ft: 4921,
      description:
        "Purola is a sub-district town in the Tons river valley of Uttarkashi district, situated at around 4,921 ft. Surrounded by terraced slopes fed by mountain streams, Purola has a long tradition of rice cultivation — unusual for a Himalayan settlement of this altitude. The valley's cool nights, clean glacial water, and organically managed soils produce a distinctly flavoured short-grain red rice that has been grown here for generations. Unlike the monsoon-heavy lowland rice belts, Purola's terraces are fed by perennial mountain streams, giving farmers reliable water through the growing season.",
    },
    farmer: {
      name: "Vandhana Rana",
      age: 36,
      gender: "Female",
      image:
        "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/red%20rice/img1.jpeg",
      bio: "Vandhana Rana grows traditional red rice on irrigated terraces in Purola, continuing a practice that stretches back generations in the Tons valley. Her variety — a short-grain, bran-rich red rice — is distinct from commercial red varieties: slower-growing, lower-yielding, but incomparably flavourful and nutritious. Vandhana uses no chemical fertilisers or pesticides, managing soil fertility through composting and traditional crop rotation. Water for irrigation comes from mountain streams managed collectively by the village, a system that has sustained these terraces for centuries.",
      calendar: [
        { icon: "🌱", phase: "Nursery", period: "May" },
        { icon: "🌾", phase: "Transplanting", period: "June – July" },
        { icon: "🍂", phase: "Harvest", period: "October – November" },
      ],
      processing: {
        practices: ["Sun Dried", "Traditional Stone Milling", "Bran Retained"],
        description:
          "After harvest, the paddy is sun-dried on the terrace walls. Vandhana Rana and her family process it through a traditional stone chakki, removing the outer husk while retaining the bran layer — preserving the deep red colour and the nutrients it contains. The milled rice is hand-sorted and packed fresh from the farm.",
      },
      videos: [
        {
          url: "https://raw.githubusercontent.com/Orangutanorganics-OUO/image_repo/refs/heads/main/Traceability_images/red%20rice/vid1.mp4",
          // label: "Paddy terraces in the Tons valley",
        }
      ],
      farms: [
        {
          label: "Farm 1",
          url: "https://www.google.com/maps/d/u/2/edit?mid=1cj4Ghx_r6VLy2977JYvJpwfbQZXeUsY&usp=sharing",
        },
      ],
      nutritionFacts: {
        servingsPerContainer: "about 7 servings per container",
        servingSize: "150 g",
        perLabel: "Amount per serving",
        calories: 510,
        rows: [
          { nutrient: "Total Fat 4g", rda: "—" },
          { nutrient: "Saturated Fat 1g", rda: "—", indent: true },
          { nutrient: "Cholesterol 0mg", rda: "—" },
          { nutrient: "Sodium 10mg", rda: "0%" },
          { nutrient: "Total Carbohydrate 105g", rda: "—" },
          { nutrient: "Dietary Fiber 4g", rda: "14%", indent: true },
          { nutrient: "Total Sugars 1g", rda: "", indent: true },
          { nutrient: "Includes 0g Added Sugars", rda: "—", indent: true },
          { nutrient: "Protein 16g", rda: "34%" },
          { nutrient: "Calcium 13mg", rda: "1%" },
          { nutrient: "Iron 20mg", rda: "70%" },
          { nutrient: "Potassium 375mg", rda: "11%" },
          { nutrient: "Magnesium 288mg", rda: "78%" },
          { nutrient: "Zinc 2.9mg", rda: "22%" },
        ],
        footnote: "* % RDA per serving, based on ICMR-NIN 2020 Recommended Dietary Allowance for a sedentary adult WOMAN (protein 46 g, fibre 30 g, calcium 1000 mg, iron 29 mg, magnesium 370 mg, zinc 13 mg, potassium 3500 mg, sodium 2000 mg, vitamin D 15 mcg). — = no ICMR RDA prescribed; declared as amount only, as per FSSAI practice.",
      },
    },
  },
};

export const PRODUCT_LIST = Object.values(PRODUCTS);
